// TODO: refactor
const getPageParts = (groupedByArticleBrandParts, pagination) => {
    const page = pagination.page
    const perPage = pagination.size

    let toSkip = (page - 1) * perPage
    let toAdd = perPage

    let result = {}

    for (const group in groupedByArticleBrandParts) {
        result[group] = []

        if (toAdd <= 0) {
            break
        }

        const cnt = groupedByArticleBrandParts[group].length

        if (cnt < toSkip) {
            toSkip -= cnt
            continue
        }

        const groupParts = groupedByArticleBrandParts[group].slice(toSkip, toSkip + toAdd)
        result[group] = groupParts

        const added = groupParts.length

        toAdd -= added
    }

    return result
}

export default getPageParts
